
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/market-insights/[slug]",
      function () {
        return require("private-next-pages/employer/market-insights/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/market-insights/[slug]"])
      });
    }
  